//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the status of a GroupMember in a Group. */
export const GroupMemberStatus = {
    /** The GroupMember is not an active member of the Group. */
    Inactive: 0,

    /** The GroupMember is an active member of the Group. */
    Active: 1,

    /** The GroupMember's membership in the Group is pending. */
    Pending: 2
} as const;

/** Represents the status of a GroupMember in a Group. */
export const GroupMemberStatusDescription: Record<number, string> = {
    0: "Inactive",

    1: "Active",

    2: "Pending"
};

/** Represents the status of a GroupMember in a Group. */
export type GroupMemberStatus = typeof GroupMemberStatus[keyof typeof GroupMemberStatus];
